import * as React from 'react'
import {
  HeroWrapper,
  HeroContainer,
  Left,
  LeftGradientEclipse,
  Right,
  Eyebrow,
  Title,
  Description,
  Actions,
  PrimaryButton,
  SecondaryButton,
  RightGradientEclipse,
  RightGradientEclipse2,
} from './styled.components'

import Image from 'next/image'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

type Props = {
  onJoinNow: () => void
}

const HeroSection: React.FC<Props> = ({ onJoinNow }) => {
  const { t } = useTranslation('about')

  return (
    <HeroWrapper>
      <HeroContainer>
        <Left className="col-span-1">
          <LeftGradientEclipse />
          <Eyebrow>{t('hero.eyebrow')}</Eyebrow>
          <Title>{t('hero.title')}</Title>
          <Description>{t('hero.description')}</Description>
          <Actions>
            <PrimaryButton onClick={onJoinNow}>
              {t('hero.joinNow')}
            </PrimaryButton>
            <SecondaryButton as={Link} href="/courses">
              {t('hero.goToApp')}
            </SecondaryButton>
          </Actions>
        </Left>

        <Right
          style={{ position: 'relative', zIndex: 2 }}
          className="col-span-1"
        >
          <RightGradientEclipse />
          <RightGradientEclipse2 />

          <Image
            src={'/static/images/about/hero-image.png'}
            width={800}
            height={800}
            alt="About Us"
            className="z-50"
          />
          {/* Background images scoped to the right column only */}
          <div
            style={{
              position: 'absolute',
              // left: 0,
              // top: 0,
              inset: 0,
              zIndex: 0,
              pointerEvents: 'none',
            }}
          >
            <Image
              src="/static/images/about/line-bg-1.png"
              alt="bg"
              fill
              style={{ objectFit: 'cover' }}
            />
          </div>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              zIndex: 1,
              pointerEvents: 'none',
            }}
          >
            <Image
              src="/static/images/about/line-bg-2.png"
              alt="bg"
              fill
              className=" min-h-full"
              style={{ objectFit: 'cover' }}
            />
          </div>
        </Right>
      </HeroContainer>
      {/* removed full hero Background - background images are now scoped to Right column */}
    </HeroWrapper>
  )
}

export default HeroSection
